import supabase from "../../../shared/database/supabase";
import { getServiceOrderResponse } from "./get-service-order";

export const getServiceOrderByPericia = async (periciaId: string) => {
  try {
    const { data, error } = await supabase.functions.invoke<getServiceOrderResponse>("get-service-order-by-pericia", {
      body: JSON.stringify({
        pericia_id: periciaId
      })
    });

    if (error) {
      console.error("Error calling get-service-order-by-pericia:", error);
      return { data: null, error };
    }
    const serviceOrder =
      data && data.service_order
        ? {
            id: data.service_order.id,
            referenceNumber: data.service_order.reference_number,
            createdAt: data.service_order.created_at ? new Date(data.service_order.created_at) : new Date(),
            updatedAt: data.service_order.updated_at ? new Date(data.service_order.updated_at) : new Date(),
            costumerId: data.service_order.costumer_id,
            createdBy: data.service_order.created_by,
            finishedBy: data.service_order.finished_by,
            finished: data.service_order.finished
          }
        : null;
    return { serviceOrder, error: null };
  } catch (err) {
    console.error("Exception in getServiceOrderByPericia:", err);
    throw err;
  }
};
